import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
//import ChatBot from 'react-simple-chatbot';
//import ChatBot from "./react-simple-chatbot-deobfuscated";
import ChatBot from "../../ChatBot/ChatBot"
import botAvatarPicture from "../../Assets/img/favicon_package_v0.16/favicon-32x32.webp"
import Review from './Review';
import ChatBotSubmit from "./ChatBotSubmit";
import { globals } from '../Globals/Globals';

class ChatBotForm extends Component {

  checkName = (value) => {
    //return value.match(/[a-zA-Zéôüïî¨öêèéÄËÏÖÜ]+[-_]*[a-zA-Zéôüïî¨öêèéÄËÏÖÜ]+/i)
    
    let trimmedValue = value.trim();
    let matchResult = trimmedValue.match(/^[a-zA-Zéôüïî¨öêèéÄËÏÖÜ]+[\s-_a-zA-Zéôüïî¨öêèéÄËÏÖÜ]*/i);
    let valueValidate = (matchResult && (matchResult[0] == trimmedValue));

    if (globals.parameters.debugging){
      console.log("value:",value)
      console.log("trimmedValue:",trimmedValue)
      console.log("matchResult:",matchResult)
      console.log("valueValidate:",valueValidate?"Ok":"Invalid value")
    }
    
    return (valueValidate);
  }


  checkSubject = (value) => {
    //return value.match(/[a-zA-Zéôüïî¨öêèéÄËÏÖÜ]+[-_]*[a-zA-Zéôüïî¨öêèéÄËÏÖÜ]+/i)
    
    let trimmedValue = value.trim();

    if (globals.parameters.debugging)
      console.log("trimmedValue:",trimmedValue)
    
    return (trimmedValue.length >1);
  }

  render() {
    // all available props
    const theme = {
      background: '#f5f8fb',
      fontFamily: 'Helvetica Neue',
      headerBgColor: 'orange',
      headerFontColor: '#fff',
      headerFontSize: '20px',
      botBubbleColor: 'orange',
      botFontColor: 'black',
      userBubbleColor: '#fff',
      userFontColor: '#4a4a4a',
    };

    return (
      <ThemeProvider theme={theme}>
      <ChatBot
        debugging = {true}
        headerTitle={this.props.headerTitle}
        opened = {this.props.opened}
        floating = {true}
        placeholder = {"Préparation de votre requête ..."}
        hideSubmitButton = {false}
        //botAvatar = {}
        botAvatar = {botAvatarPicture}
        floatingIcon = {botAvatarPicture}
        enableSmoothScroll = {true}
        enableMobileAutoFocus= {false}

        steps={[
          {
            id: 'whom',
            message: 'Pour qui devons nous prier ?',
            trigger:'target',
          },
          {
            id: 'target',
            user: true,
            placeholder:"Entrez un prénom...",
            validator: (value) => {
              if (!this.checkName(value)){
                return 'Prénom trop court ou contient des chiffres';
              }
              return true;
            },
            trigger: 'category-question'
          },
          {
            id: 'category-question',
            message: "Quel est le domaine ?",
            trigger: 'category',
          },
          {
            id: 'category',
            options: [
                { value: '3', label: 'Renforcement spirituel', trigger: 'subject-question' },
                { value: '4', label: 'Guérison d\'une maladie', trigger: 'subject-question'},
                { value: '5', label: 'Soutien social', trigger: 'subject-question'},
                { value: '1', label: 'Support missionnaire', trigger: 'subject-question'},
              ],
          },
          {
            id: 'subject-question',
            message: "Décrivez succintement votre sujet de prière",
            trigger: 'subject',
          },
          {
            id: 'subject',
            user: true,
            placeholder:"Entrez le sujet...",
            validator: (value) => {
              if (!this.checkSubject(value)){
                return 'Le sujet est trop court';
              }
              
              return true;
            },
            trigger: 'summary'
          },
          
          {
            id: 'summary',
            message: 'Parfait, récapitulons votre sujet de prière',
            trigger: 'review',
          },
          {
            id: 'review',
            component: <Review email={this.props.email}/>,
            asMessage: true,
            trigger: 'update',
          },
          {
            id: 'update',
            message: 'Voulez-vous modifier quelque-chose?',
            trigger: 'update-question',
          },
          {
            id: 'update-question',
            options: [
              { value: 'yes', label: 'Oui', trigger: 'update-yes' },
              { value: 'no', label: 'Non', trigger: 'ChatBotSumbmit' },
              { value: 'restart', label: 'Tout recommencer', trigger: 'whom' },
            ],
          },
          {
            id: 'update-yes',
            message: 'Que souhaiteriez-vous modifier ?',
            trigger: 'update-fields',
          },
          {
            id: 'update-fields',
            options: [
              { value: 'target', label: 'Le bénéficiaire', trigger: 'update-target' },
              { value: 'category', label: 'La catégorie de prière', trigger: 'update-category' },
              { value: 'subject', label: 'Le sujet de prière', trigger: 'update-subject' }
            ],
          },
          {
            id: 'update-target',
            update: 'target',
            trigger_old: 'target_message',
            trigger: 'summary',
          },
          {
            id: 'update-category',
            update: 'category',
            trigger: 'summary',
          },
          {
            id: 'update-subject',
            update: 'subject',
            trigger: 'summary',
          },

          {
            id: 'ChatBotSumbmit',
            component: <ChatBotSubmit email={this.props.email}/>,
            asMessage: true,
            trigger: 'restart-question',
          },

          {
            id: 'restart-question',
            message: 'Souhaitez-vous soumettre un nouveau sujet ?',
            trigger: 'restart',
          },
          {
            id: 'restart',
            options: [
              { value: 'yes', label: 'Oui', trigger: 'whom' },
              { value: 'no', label: 'Non', trigger: 'stop' },
            ],
          },
          {
            id: 'stop',
            message: 'Merci, soyez bénis en Jésus-Christ',
            end:true,
          },
        ]}
      />
      </ThemeProvider>
    );
  }
}

export default ChatBotForm;